module.exports = __webpack_public_path__ + "static/media/img_overpaper4@2x.c2bf3bb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_overpaper4@2x.png
// module id = 968
// module chunks = 0